import styled, { css } from "styled-components";

interface IStyledButton {
  emphasis: boolean;
  small: boolean;
}

export const StyledButton = styled.button<IStyledButton>`
  border-radius: 8px;
  border: none;
  min-width: 200px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ small }) =>
    small &&
    css`
      height: 30px;
    `}
  font-size: 2rem;
  font-family: var(--default-text);
  color: var(--details-color);
  background-color: var(--secondary-color);

  ${({ emphasis }) =>
    emphasis &&
    css`
      background-color: var(--tertiary-color-main-buttons);
      color: var(--primary-color);
    `}
  &:hover {
    box-shadow: 0 0 0.5rem black;
  }
  &:active {
    box-shadow: 0 0 0.8rem black;
  }
  &.products,
  &.services {
    background-color: var(--primary-color);
    border: 2px solid var(--secondary-color);
    color: var(--secondary-color);
    margin: 0.5rem;
  }
  &.focusedServices,
  &.focusedProducts {
    margin: 0.5rem;
    :focus {
      color: var(--details-color);
      background-color: var(--secondary-color);
    }
  }
`;
